"use strict";
import Honeybadger from "@honeybadger-io/js";
const NAME = "CsrfRejectionNotRetried";
const MISPLACED_META_NAME = "CsrfMetaOutsideHead";
const DESCRIBED_CHILDREN = 5;
const describeElement = (element) => [
  element.tagName.toLowerCase(),
  element.id ? `#${element.id}` : "",
  element.classList.length ? `.${[...element.classList].join(".")}` : ""
].join("");
const describeChildren = (parent) => {
  var _a;
  return [...(_a = parent == null ? void 0 : parent.children) != null ? _a : []].slice(0, DESCRIBED_CHILDREN).map(describeElement);
};
export function reportMisplacedCsrfMeta(meta) {
  try {
    Honeybadger.notify(MISPLACED_META_NAME, {
      name: MISPLACED_META_NAME,
      fingerprint: MISPLACED_META_NAME,
      context: {
        path: location.pathname,
        ready_state: document.readyState,
        ms_since_page_load: Math.round(performance.now()),
        meta_parent: meta.parentElement ? describeElement(meta.parentElement) : null,
        head_children: describeChildren(document.head),
        body_children: describeChildren(document.body)
      }
    });
  } catch (e) {
    return;
  }
}
export function reportUnretriedRejection({
  reason,
  transport,
  method,
  url,
  status
}) {
  try {
    Honeybadger.notify(`${NAME}: ${reason}`, {
      name: NAME,
      fingerprint: NAME,
      context: {
        reason,
        transport,
        method,
        path: new URL(url, location.href).pathname,
        status,
        ms_since_page_load: Math.round(performance.now())
      }
    });
  } catch (e) {
    return;
  }
}
